module.exports = __webpack_public_path__ + "static/media/brillumex-5.dacd43b7.jpg";